// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  contractId: __t.u64().primaryKey().name("contract_id"),
  kind: __t.string(),
  issuerKind: __t.string().name("issuer_kind"),
  issuer: __t.identity(),
  originSid: __t.u64().name("origin_sid"),
  destSid: __t.u64().name("dest_sid"),
  title: __t.string(),
  note: __t.string(),
  reward: __t.i64(),
  collateral: __t.i64(),
  commodity: __t.string(),
  qty: __t.u32(),
  delivered: __t.u32(),
  caravanId: __t.u64().name("caravan_id"),
  recipient: __t.identity(),
  state: __t.string(),
  taker: __t.identity(),
  takenAt: __t.timestamp().name("taken_at"),
  hours: __t.u32(),
  deadline: __t.timestamp(),
  postedAt: __t.timestamp().name("posted_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
